import createClient from 'openapi-fetch';

// This API is also used on the frontend, so we just don't import that logger middleware.
// import generateOpenApiFetchLoggingMiddleware from 'src/generateOpenApiFetchLoggingMiddleware';
export type { components } from './schema';
import { paths } from './schema';

const locationApiClient = createClient<paths>({
  baseUrl: 'https://kr5iknsvo9.execute-api.us-east-2.amazonaws.com',
});

// locationApiClient.use(generateOpenApiFetchLoggingMiddleware('locationApi'));

export default locationApiClient;
